import { FGLink } from '@fg/design-system';

type Props = {
  demoLink: string;
  appName: string;
  appCode: string;
};
export const DemoNoteView = ({ demoLink, appName, appCode }: Props) => {
  const demoUrl = decodeURIComponent(demoLink);
  const isFc = appCode === 'fitchConnect';
  const isFrp = appCode === 'frp';
  const isBmi = appCode === 'bmi';
  const isGq = appCode === 'geoquant';
  const isNgw = isBmi || isFrp || isGq;

  interface DemoNoteViewConfig {
    isNgw: boolean;
    requestDemoText: string;
    requestDemoLinkText: string;
    learnMoreUrl: string;
    learnMoreText: string;
  }

  const demoNoteViewConfigs: { [key: string]: DemoNoteViewConfig } = {
    frp: {
      isNgw: true,
      requestDemoText: 'Interested in a subscription?',
      requestDemoLinkText: 'Request a callback',
      learnMoreUrl:
        'https://www.fitchsolutions.com/credit/fitch-ratings-pro?utm_campaign=frpro-login&utm_medium=referral&utm_source=fr-pro&utm_content=lnk1&utm_term=learn-more',
      learnMoreText: 'Fitch Ratings PRO is the delivery platform for Fitch Ratings Research & Data subscribers.',
    },
    bmi: {
      isNgw: true,
      requestDemoText: 'Interested in a subscription?',
      requestDemoLinkText: 'Request a callback',
      learnMoreUrl:
        'https://www.fitchsolutions.com/bmi/platform?utm_campaign=bmi-login&utm_medium=referral&utm_source=bmi-platform&utm_content=lnk1&utm_term=learn-more',
      learnMoreText: 'Access to this platform is for BMI political, economic & industry insights subscribers.',
    },
    geoquant: {
      isNgw: true,
      requestDemoText: 'Interested in a subscription?',
      requestDemoLinkText: 'Request a callback',
      learnMoreUrl:
        'https://www.fitchsolutions.com/bmi/political-risk-service#form',
      learnMoreText: 'Access to this platform is for GeoQuant subscribers only.',
    },
  };

  const defaultDemoNoteViewConfig: DemoNoteViewConfig = {
    isNgw: false,
    requestDemoText: isFc
      ? 'Fitch Connect is being replaced by new, improved, and independent delivery platforms for each Fitch Solutions business unit. Existing users will receive an email with full details and login credentials when it’s time to migrate.'
      : `New to ${appName}?`,
    requestDemoLinkText: 'Request a demo',
    learnMoreUrl: '',
    learnMoreText: '',
  };

  const demoNoteViewConfig = demoNoteViewConfigs[appCode] || defaultDemoNoteViewConfig;

  const demoLinkStyling = {
    fontWeight: 'bold',
    marginTop: '15px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  return (
    <>
      <div
        className="tab-panel-content"
        style={{
          borderTop: '1px solid rgba(26, 26, 26, 0.08)',
        }}
      />
      <div className="fg-pd--t6">
        {isNgw && (
          <div className="fg-pd--b2 fg-ai--c fg-jc--c fg-d--f">
            <p className="fg-body3-short fg-mg--0">
              {demoNoteViewConfig.learnMoreText}
              <FGLink
                href={demoNoteViewConfig.learnMoreUrl}
                appearance="blue"
                className="fg-body3-short pi-request-demo fg-mg--l1"
              >
                Learn more
              </FGLink>
            </p>
          </div>
        )}
        {isFc ? (
          <div
            style={{
              textAlign: 'center',
              maxWidth: '630px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <p className="fg-body3-short fg-mg--0 fg-mg--r1">{demoNoteViewConfig.requestDemoText}</p>
            <div
              className="fg-pd--b10 fg-ai--c fg-jc--c"
              style={{
                display: 'flex',
                maxWidth: '424px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <FGLink
                href="https://www.fitchsolutions.com/credit/fitch-ratings-pro?utm_campaign=fc-login&utm_medium=referral&utm_source=fitch-connect&utm_content=lnk1&utm_term=discover-fr-pro"
                appearance="default"
                isInline={true}
                style={demoLinkStyling}
                className="fg-body3-short pi-request-demo"
              >
                Discover Fitch Ratings PRO
              </FGLink>
              <FGLink
                href="https://www.fitchsolutions.com/bmi/platform?utm_campaign=fc-login&utm_medium=referral&utm_source=fitch-connect&utm_content=lnk1&utm_term=explore-new-experience"
                appearance="default"
                isInline={true}
                style={demoLinkStyling}
                className="fg-body3-short pi-request-demo"
              >
                Explore BMI Web Experience
              </FGLink>
            </div>
          </div>
        ) : (
          <div className="fg-pd--b10 fg-ai--c fg-jc--c tab-panel-content">
            <p className="fg-body3-short fg-mg--0 fg-mg--r1">{demoNoteViewConfig.requestDemoText}</p>
            <FGLink href={demoUrl} appearance="blue" className="fg-body3-short pi-request-demo">
              {demoNoteViewConfig.requestDemoLinkText}
            </FGLink>
          </div>
        )}
      </div>
    </>
  );
};
